var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGunrunnercardEnergy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 10,
    viewBox: "0 0 42 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.94286 0H14.5091L4.58182 9.16364H0L9.94286 0Z",
    fill: "#6A91F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8159 0H21.3821L11.4549 9.16364H6.87305L16.8159 0Z",
    fill: "#6A91F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.688 0H28.2542L18.3269 9.16364H13.7451L23.688 0Z",
    fill: "#6A91F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4341 0H42.0003L32.073 9.16364H27.4912L37.4341 0Z",
    fill: "#6A91F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.561 0H35.1273L25.2 9.16364H20.6182L30.561 0Z",
    fill: "#6A91F6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGunrunnercardEnergy);
export default __webpack_public_path__ + "static/media/gunrunnercard_energy.aa0e7bb3b4364ffad353b8aec2e08da1.svg";
export { ForwardRef as ReactComponent };